import { createRef } from "react";

const FOOTER_CART_TOUR_TARGET_CLASS = "footer-cart-guide-tour";

export const FOOTER_CART_GUIDE_TOUR_USER_CONFIG = {
  viewedUserConfigField: "automatedCatalogFooterCartGuideTourViewed",
  modifyUserInput: { automatedCatalogFooterCartGuideTourViewed: true },
};

export const getFooterCartTourStepsData = () => ({
  step1: {
    id: 1,
    name: "editSwagCollectionName",
    placement: "top-start",
    ref: createRef(),
    targetClass: FOOTER_CART_TOUR_TARGET_CLASS,
    imgSrc: "",
    title: "Edit your swag collection name",
    textData: "Edit your collection name anytime to keep things organized.",
    showCloseCta: true,
    hideTourImage: true,
  },
  step2: {
    id: 2,
    name: "countrySwagAvailability",
    placement: "top-start",
    ref: createRef(),
    targetClass: FOOTER_CART_TOUR_TARGET_CLASS,
    imgSrc: "",
    title: "Country Swag Availability",
    textData:
      "Check the country dropdown to see which products are available for your team in each country.",
    showCloseCta: true,
    hideTourImage: true,
  },
  step3: {
    id: 3,
    name: "uploadArtwork",
    placement: "top-end",
    ref: createRef(),
    targetClass: FOOTER_CART_TOUR_TARGET_CLASS,
    imgSrc: "",
    title: "Upload your artwork",
    textData:
      "It's time for the best part! Upload your artwork to start bringing your swag to life.",
    showCloseCta: true,
    hideTourImage: true,
  },
});
